import { useEffect, useRef } from 'react';
import { useSnackbar } from 'notistack';
import Button from '@mui/material/Button';

// 定期检查线上是否已发布新版本(比对 index.html 里引用的 main.js 文件名):
// 已打开的标签页发布后会一直跑内存里的旧代码、请求旧接口拿到不完整/不一致的数据,
// 用户很难自己意识到"页面该刷新了";发现版本变化时主动提示,而不是让用户默默看到不一致的数据。
const CHECK_INTERVAL_MS = 3 * 60 * 1000; // 3分钟轮询一次

const extractMainJs = (html) => {
  const m = html.match(/\/static\/js\/main\.[a-zA-Z0-9]+\.js/);
  return m ? m[0] : null;
};

const VersionWatcher = () => {
  const { enqueueSnackbar } = useSnackbar();
  const currentRef = useRef(null);
  const notifiedRef = useRef(false);

  useEffect(() => {
    // 记录当前页面正在跑的 main.js 文件名,来自当前 DOM 里的 script 标签(与构建产物一一对应)
    const scriptEl = document.querySelector('script[src*="/static/js/main."]');
    currentRef.current = scriptEl ? scriptEl.getAttribute('src') : null;

    const check = async () => {
      if (notifiedRef.current || !currentRef.current) return;
      try {
        const res = await fetch('/', { cache: 'no-store' });
        const html = await res.text();
        const latest = extractMainJs(html);
        if (latest && latest !== currentRef.current) {
          notifiedRef.current = true;
          enqueueSnackbar('检测到新版本已上线,当前页面的数据可能不是最新的', {
            variant: 'info',
            persist: true,
            action: () => (
              <Button size="small" sx={{ color: '#fff', fontWeight: 700 }} onClick={() => window.location.reload()}>
                立即刷新
              </Button>
            )
          });
        }
      } catch (e) {
        /* 检查失败静默忽略,不影响正常使用 */
      }
    };

    const timer = setInterval(check, CHECK_INTERVAL_MS);
    const onVisible = () => {
      if (document.visibilityState === 'visible') check();
    };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [enqueueSnackbar]);

  return null;
};

export default VersionWatcher;
